import { MobileDrawerStoreState } from './types';

export const mobileDrawerStoreSelector = {
  // State
  isOpen: (state: MobileDrawerStoreState): MobileDrawerStoreState['isOpen'] =>
    state.isOpen,
  snapPoint: (
    state: MobileDrawerStoreState
  ): MobileDrawerStoreState['snapPoint'] => state.snapPoint,
  activePanel: (
    state: MobileDrawerStoreState
  ): MobileDrawerStoreState['activePanel'] => state.activePanel,
  availableSnapPoints: (
    state: MobileDrawerStoreState
  ): MobileDrawerStoreState['availableSnapPoints'] => state.availableSnapPoints,

  // Actions
  setState: (
    state: MobileDrawerStoreState
  ): MobileDrawerStoreState['setState'] => state.setState,
  setIsOpen: (
    state: MobileDrawerStoreState
  ): MobileDrawerStoreState['setIsOpen'] => state.setIsOpen,
  setSnapPoint: (
    state: MobileDrawerStoreState
  ): MobileDrawerStoreState['setSnapPoint'] => state.setSnapPoint,
};
